// extracted by mini-css-extract-plugin
export default {"wizard":"app-onboarding_wizard__wEczF","container":"app-onboarding_container__6016n"};